// Thin wrapper around student_profile_service's "My Availability" routes
// (docs/DECISIONS.md, "My Availability" decision), mirroring
// studentProfile.js's apiFetch/origin-constant style.

import { apiFetch, STUDENT_PROFILE_SERVICE_ORIGIN } from './api';

// { slots: [{slot_id, day_of_week, start_time, end_time, created_time}], locked: bool }
export async function getMyAvailability() {
  const response = await apiFetch('/api/student-profile/availability', {}, STUDENT_PROFILE_SERVICE_ORIGIN);
  if (!response.ok) return { slots: [], locked: false };
  return response.json();
}

export async function createAvailabilitySlot({ day_of_week, start_time, end_time }) {
  return apiFetch(
    '/api/student-profile/availability',
    { method: 'POST', body: JSON.stringify({ day_of_week, start_time, end_time }) },
    STUDENT_PROFILE_SERVICE_ORIGIN
  );
}

export async function deleteAvailabilitySlot(slotId) {
  return apiFetch(
    `/api/student-profile/availability/${encodeURIComponent(slotId)}`,
    { method: 'DELETE' },
    STUDENT_PROFILE_SERVICE_ORIGIN
  );
}

export async function clearMyAvailability() {
  return apiFetch('/api/student-profile/availability', { method: 'DELETE' }, STUDENT_PROFILE_SERVICE_ORIGIN);
}

// Locks the student's availability (their own "Save Availability" click) -
// after this, only a Mentor/Admin can change it (docs/DECISIONS.md, "My
// Availability" decision - "once filled, weekly availability becomes
// readonly").
export async function lockMyAvailability() {
  return apiFetch('/api/student-profile/availability/lock', { method: 'POST' }, STUDENT_PROFILE_SERVICE_ORIGIN);
}
